import styled from "@emotion/styled";
import { colors, fontFamily, media, pxtorem } from "../../../assets/styles/theme";
import leftNavigationBg from "../../../assets/images/leftNavigationBg.svg";


// left navigation style
export const LeftNavigationStyled = styled.div`   
  width: 223px;
  min-width: 223px;
  height: 100%;
  background-image: url(${leftNavigationBg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right 0;  
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  ${media.mmd`
    width: 180px;
    min-width: 180px;
  `}

  ${media.xxxl`
    width: 350px;
    min-width: 350px;
  `}

  .MuiList-root {
    padding: 10px 0 0 0;
  }
  .MuiListItem-root {
    position: relative;    
    padding-right: 30px;    
    .MuiButtonBase-root{
      min-height: 42px;
      display: flex;
      align-items: center;
    }
   
    .MuiListItemText-primary {
      font-family: ${fontFamily.karla};
      font-weight: 700;
      font-size: ${pxtorem(12)};
      color: ${colors.darkestGray};
      text-transform: uppercase;      
    }
    .MuiButtonBase-root {
      padding-left: 4px;
      background-color: transparent;
      &.Mui-selected, &:hover{
        .MuiListItemText-primary {
          color: ${colors.white};
        }
        .MuiListItemIcon-root svg{   
          fill:${colors.white};       
        }   
        &:after  {
          background: linear-gradient(90deg, #41B44A, #C4D82F);
        }
      
      }
      &:after  {
        width: 4px;
        background: transparent;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        content: '';      
      }  
    }    
    .MuiListItemIcon-root {
      min-width: 40px;
      svg {
        fill:${colors.darkestGray};
        margin: 0 auto;
      }
    }    
  }
  .MuiButtonBase-root {
    padding: 0;
    .MuiListItemText-root {
      margin: 0;
    }
  }
  .top-border {
    &::before{
      content:'';
      width: 160px;
      height: 1px;
      background-color: ${colors.lightierGray};
      opacity: .3;
      position: absolute;
      top: 0;
    }
    
  }
  .CopyRightText {
      font-weight: 400;
      font-size: ${pxtorem(10)};
      line-height: 1.16;
      color: ${colors.darkestWhite};
      padding: 0 0 25px 0;
      text-align: center;
      max-width: 152px;
      ${media.mmd`
        max-width: 126px;
        text-shadow: 1px 1px 6px ${colors.black};
      `}
  }
  
`;